module.exports = __webpack_public_path__ + "static/media/my-activities-un-active.76918720.svg";